import { ActionType } from 'src/types/common/common';

import { ResponsiveGridAdaptor } from 'src/constrains/DraggableModules/Components';
import { generateNewContentPage } from 'src/components/Modules/Components/ContentImageDragItem/tools';
import { randomNumber } from '@/src/tools/helper';

const ResponsiveContentGridFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnGridItemAdd = (id, data) => {
    const _n = { draggableId: randomNumber(), ...generateNewContentPage() };
    const _o = data || [_n];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: _o });
    }
  };

  const handleOnGridItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnGridItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };

  const handleOnGridItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnGridStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnGridModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };

  return {
    handleOnGridItemAdd,
    handleOnGridItemDelete,
    handleOnGridItemChange,
    handleOnGridItemSort,
    handleOnGridStaticChange,
    handleOnGridModuleTypeChange,
  };
};
const generateResponsiveContentGrid = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const {
    handleOnGridItemAdd,
    handleOnGridItemDelete,
    handleOnGridItemChange,
    handleOnGridItemSort,
    handleOnGridStaticChange,
    handleOnGridModuleTypeChange,
  } = ResponsiveContentGridFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: ResponsiveGridAdaptor,
    props: {
      onItemAdd: handleOnGridItemAdd,
      onItemChange: handleOnGridItemChange,
      onItemSort: handleOnGridItemSort,
      onItemDelete: handleOnGridItemDelete,
      onStaticChange: handleOnGridStaticChange,
      onModuleTypeChange: handleOnGridModuleTypeChange,
    },
  };
};
export { generateResponsiveContentGrid };
